import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent } from '../../common/button/components/button/button.component';
import { GroupComponent } from '../../common/group/group.component';
import { NotificationBodyBase } from '../notification-body-base';
import { NotificationData } from '../notification-data';
import { TextSwapComponent } from '../text-swap.component';

@Component({
  selector: 'rt-notification-body',
  template: `
    @if (title) {
      <span class="title">{{ title }}</span>
    }
    @if (message) {
      <span class="message">{{ message }}</span>
    }
    @if (messageHTML) {
      <span class="message">
        <rt-text-swap [isHtml]="true" [text]="messageHTML"></rt-text-swap>
      </span>
    }
    @if (actionButtonLabel) {
      <rt-group margin-top-small-x>
        <rt-button (click)="actionButtonClick.emit()" variant="tertiary" margin-top>
          {{ actionButtonLabel }}
        </rt-button>
      </rt-group>
    }
  `,
  styleUrls: ['./notification-body.component.less'],
  standalone: true,
  imports: [TextSwapComponent, GroupComponent, ButtonComponent],
})
export class NotificationBodyComponent extends NotificationBodyBase {
  @Input() public title?: string;
  @Input() public message?: string;
  @Input() public messageHTML?: string;
  @Input() public actionButtonLabel?: string;
  @Output() public actionButtonClick: EventEmitter<void> = new EventEmitter();

  /**
   * @deprecated
   */
  @Input() public data?: any;

  constructor(
    private _data: NotificationData,
    protected cdRef: ChangeDetectorRef,
  ) {
    super();

    this.title = _data.title;
    this.message = _data.message;
    this.messageHTML = _data.messageHTML;
    this.actionButtonLabel = _data.actionButtonLabel;
  }

  public setTitle(title: string): void {
    this.title = title;
    this.cdRef.detectChanges();
  }

  public setMessage(message: string): void {
    this.message = message;
    this.cdRef.detectChanges();
  }

  public setMessageHTML(messageHTML: string): void {
    this.messageHTML = messageHTML;
  }
}
